<h2>Witaj w nowym Zalamo!</h2>
@if (isMobile$ | async) {
} @else {
  <div class="point">
    Nowe sesje możesz dodawać klikając w ikonę
    <mat-icon (pointerenter)="showAddHover()" (pointerleave)="hideHover()"
      >add_circle
    </mat-icon>
    w menu po lewej
  </div>
  <div class="point">
    Zamówienia ze wszystkich sesji znajdziesz klikając w
    <mat-icon
      (pointerenter)="showOrdersHover()"
      (pointerleave)="hideHover()"
      svgIcon="s_order_list"
      >
    </mat-icon>
    w menu po lewej. Zamówienia z konkretnej sesji znajdziesz tej w samej sesji
  </div>
}
